module.exports = __webpack_public_path__ + "public/img/logo.d39c71ef.png";